import { css } from '@utils/css';

const visuallyHidden = css`
  position: absolute;
  top: auto;
  left: -10000px;

  height: 1px;
  width: 1px;

  overflow: hidden;
`;

/**
 * Forces content to only be visible on a screen-reader
 *
 * See https://webaim.org/techniques/css/invisiblecontent/
 */
const screenReaderOnlyCls = "hd6s1hura4t";
const visibleOnFocusCls = "hd6v1ed9h3h";

export { screenReaderOnlyCls, visibleOnFocusCls, visuallyHidden };
import "./screen-reader.linaria.module.css";
//# sourceMappingURL=screen-reader.js.map
